<template>
  <div
    :class="deleteLoading ? 'loading-style' : ''"
    v-loading="deleteLoading || fetchAreaDetailLoading"
  >
    <el-form
      label-width="130px"
      :model="form"
      ref="form"
      :rules="rules"
      :label-position="$root.screenWidth >= 550 ? 'left' : 'top'"
    >
      <el-form-item :label="$t('text.area_filter_name')" prop="areaFilterName">
        <el-input
          v-model="form.areaFilterName"
          :placeholder="$t('text.area_filter_name')"
        ></el-input>
      </el-form-item>
      <el-form-item :label="$t('text.facility')" prop="building">
        <el-select
          v-model="form.building"
          filterable
          :placeholder="$t('text.select')"
          class="wp-100"
          @change="getAreaOptions"
        >
          <el-option
            v-for="building in buildings"
            :key="building.BuildingId"
            :label="building.BuildingName"
            :value="building.BuildingId"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('text.area')" prop="area">
        <el-cascader
          class="wp-100"
          :key="Math.random()"
          filterable
          ref="areaSelector"
          :placeholder="$t('text.select')"
          v-model="form.area"
          :options="areaOptions"
          :props="{ expandTrigger: 'hover', emitPath: false, multiple: true }"
          popper-class="area-poper custom-cascader"
        >
          <template slot="empty">
            <div>
              <li class="el-cascader__empty-text">
                {{
                  form.building
                    ? $t('text.no_data')
                    : $t('text.please_select_facility_first')
                }}
              </li>
            </div>
          </template>
        </el-cascader>
      </el-form-item>
    </el-form>
    <div class="filter-summary" v-if="form.building && form.area.length">
      <div class="title">{{ $t('text.filter_summary') }}</div>
      <div>
        {{ $t('text.show_patients_from') }}
        <b>{{ selectedOrganisationName }}</b> {{ $t('text.in') }}
        <b>{{ selectedBuildingName }}</b> {{ $t('text.belonging_to') }}
        <b>
          <span v-for="(floor, index) in selectedFloor" :key="floor.value">{{
            index !== selectedFloor.length - 1
              ? floor.label + ', '
              : floor.label
          }}</span>
        </b>
        {{ $t('text.and') }}
        <b>
          <span v-for="(room, index) in selectedRoom" :key="room.value">{{
            index !== selectedRoom.length - 1 ? room.label + ', ' : room.label
          }}</span
          >.</b
        >
      </div>
    </div>
    <div class="text-right mt-15">
      <div
        class="pointer red-font underline inline-block"
        @click="deleteArea()"
      >
        <i class="el-icon-delete"></i>
        <span class="ml-5">{{ $t('text.delete_area') }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import ApiService from '@/services/ApiService.js'
import swal from 'sweetalert'
import _ from 'lodash'
export default {
  data() {
    return {
      loading: false,
      allAreaFilters: [],
      organisations: this.$store.getters[`user/userOwnedOrganisations`],
      buildings: [],
      areaOptions: [],
      form: {
        areaFilterName: '',
        building: '',
        area: []
      },
      rules: {
        areaFilterName: [
          {
            required: true,
            message: this.$t('text.please_enter_area_filter_name'),
            trigger: 'blur'
          }
        ],
        building: [
          {
            required: true,
            message: this.$t('text.please_select_facility'),
            trigger: 'blur'
          }
        ],
        area: [
          {
            required: true,
            message: this.$t('text.please_select_floor_and_room'),
            trigger: 'blur'
          }
        ]
      },
      selectedOrganisationName: '',
      selectedBuildingName: '',
      selectedFloor: [],
      selectedRoom: [],
      fetchAreaDetailLoading: false,
      deleteLoading: false
    }
  },
  props: {
    areaFilterId: {
      type: String
    }
  },
  mounted() {
    this.loadBasicInfo()
  },
  watch: {
    'form.building': function(val, oldVal) {
      if (!val) return
      this.calcSelectedBuildingName()
      if (oldVal) {
        this.form.area = []
      }
    },
    'form.area': function(val) {
      if (val.length === 0) return
      this.calcSelectedArea()
    },
    areaFilterId(val) {
      if (!val) return
      this.getAreaDetail()
    },
    loading(val) {
      this.$emit('loadingChange', val)
    }
  },
  methods: {
    loadBasicInfo() {
      this.fetchAreaDetailLoading = true
      this.$store.dispatch('filter/getBuildings').then(() => {
        this.fetchAreaDetailLoading = false
        this.buildings = this.buildings.concat(
          this.$store.state.filter.buildings
        )
        this.getAreaDetail()
      })
      this.calcSelectedOrganisationName()
    },
    getAreaOptions() {
      let allFloors = this.buildings.filter(
        building => building.BuildingId === this.form.building
      )
      this.areaOptions = allFloors[0].Floors.map(floor => {
        let children = floor.Rooms.map(room => {
          return {
            ...room,
            value: room.RoomId,
            label: room.RoomNumber
          }
        })
        children.unshift({
          value: 'Room',
          label: this.$t('text.room'),
          children: []
        })
        return {
          ...floor,
          value: floor.FloorId,
          label: floor.FloorName,
          children: children
        }
      })
      this.areaOptions.unshift({
        value: 'Floor',
        label: this.$t('text.floor'),
        children: []
      })
    },
    getAreaDetail() {
      this.fetchAreaDetailLoading = true
      ApiService.GetAreaByIds([this.areaFilterId])
        .then(response => {
          this.fetchAreaDetailLoading = false
          if (response.data.success) {
            let areaDetail = response.data.data[0]
            this.form.building = areaDetail.Ward.BuildingId
            this.form.areaFilterName = areaDetail.Ward.Name
            this.form.area = areaDetail.WardRoom.map(item => {
              return item.RoomId
            })
            this.getAreaOptions()
          } else {
            swal({
              icon: 'error',
              timer: 2000,
              title: this.$t('text.failed'),
              text: response.data.msg
            })
          }
        })
        .catch(() => {
          this.fetchAreaDetailLoading = false
        })
    },
    calcSelectedOrganisationName() {
      this.organisations.forEach(organisation => {
        if (
          organisation.OrganisationName.OrganisationId ===
          this.$store.getters[`user/selecteOrganisationId`]
        ) {
          this.selectedOrganisationName = organisation.OrganisationName.Name
        }
      })
    },
    calcSelectedBuildingName() {
      this.buildings.forEach(building => {
        if (building.BuildingId === this.form.building) {
          this.selectedBuildingName = building.BuildingName
        }
      })
    },
    calcSelectedArea() {
      this.$nextTick(() => {
        this.selectedFloor = []
        this.selectedRoom = []
        let allCheckedNodes = this.$refs.areaSelector.getCheckedNodes(true)
        allCheckedNodes.forEach(node => {
          this.selectedRoom.push({
            label: node.label,
            value: node.value
          })

          this.selectedFloor.push({
            label: node.parent.label,
            value: node.parent.value
          })
          this.selectedFloor = _.uniqWith(this.selectedFloor, _.isEqual)
        })
      })
    },
    submit() {
      let allCheckedNodes = this.$refs.areaSelector.getCheckedNodes()
      let roomIds = allCheckedNodes
        .filter(node => node.level === 2)
        .map(item => item.value)
      this.$refs.form.validate(valid => {
        if (valid) {
          this.loading = true
          ApiService.SaveAreaDetail({
            WardId: this.areaFilterId,
            BuildingId: this.form.building,
            AreaName: this.form.areaFilterName,
            RoomIds: roomIds
          })
            .then(response => {
              this.loading = false
              if (response.data.success) {
                swal({
                  icon: 'success',
                  timer: 2000,
                  title: this.$t('text.saved_successfully')
                })
                this.$store.dispatch('filter/getAreaFilters')
              } else {
                swal({
                  icon: 'error',
                  timer: 2000,
                  title: this.$t('text.failed'),
                  text: response.data.msg
                })
              }
            })
            .catch(() => {
              this.loading = false
            })
        }
      })
    },
    deleteArea() {
      let warningIconUrl = require('@/assets/image/warning-icon/warning.svg')
      this.$confirm(
        `<div class='warning-content'>${this.$t(
          'text.keep_in_mind_delete_area'
        )}</div><img class='warning-icon' src=${warningIconUrl}>`,
        this.$t('text.you_able_to_delete_data') +
          ' ' +
          this.form.areaFilterName,
        {
          confirmButtonText: this.$t('text.delete').toUpperCase(),
          cancelButtonText: this.$t('text.cancel').toUpperCase(),
          confirmButtonClass: 'confirm-btn',
          cancelButtonClass: 'cancel-btn',
          type: 'warning',
          customClass: 'delete-warning-box',
          showClose: true,
          closeOnClickModal: false,
          dangerouslyUseHTMLString: true
        }
      ).then(() => {
        this.handleDelete()
      })
    },
    handleDelete() {
      this.deleteLoading = true
      ApiService.DeleteWard(this.areaFilterId)
        .then(response => {
          if (response.data.success) {
            this.$store.dispatch('filter/getAreaFilters').then(() => {
              this.deleteLoading = false

              // If the deleted area is selected, the area selection will be cleared
              if (
                this.$store.state.filter.dashboardFilter.filterIds.includes(
                  this.areaFilterId
                )
              ) {
                this.$store.state.filter.dashboardFilter.filterIds = []
              }
              this.$emit('deleteSuccess')
              swal({
                icon: 'success',
                timer: 2000,
                title: this.$t('text.deleted_successfully')
              })
            })
          } else {
            swal({
              icon: 'error',
              timer: 2000,
              title: this.$t('text.failed'),
              text: response.data.msg
            })
          }
        })
        .catch(() => {
          this.deleteLoading = false
        })
    }
  }
}
</script>
